import React from 'react'


export default function AdminSetup() {
    const role = localStorage.getItem('role')
    if (role !== 'SUPERADMIN') return <div className="container">Adgang nægtet</div>


    const generateKey = async () => {
        const res = await fetch('/api/admin/generate-key', {
            method: 'POST',
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        })
        if (!res.ok) { alert('Fejl ved generering'); return }
        const data = await res.json()
        // show once
        alert('Admin key (copy and share): ' + data.key)
    }


    return (
        <div className="container">
            <h1>SuperAdmin Setup</h1>
            <p>Klik "Generer" for at få en engangs-nøgle til trusted admin signup.</p>
            <button onClick={generateKey}>Generer Admin-nøgle</button>
        </div>
    )
}